import { makeStyles, Theme } from "@material-ui/core";

export const useStyles = makeStyles((theme: Theme) => ({
    input: {
        "&:-webkit-autofill": {
            WebkitBoxShadow: "0 0 0 1000px white inset"
        },
        fontFamily: "Helvetica"
    },
    formControl: {
        margin: theme.spacing(1),
        width: '100%'
    },
    loaderDiv: {
        color: "#ccc7c7"
    }
}));
export const useStylesAddress = makeStyles((theme: Theme) => ({
    formControl: {
        margin: theme.spacing(1),
        width: '100%'
    }
}));